var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F1B44C",
    fillOpacity: 0.25098
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.6667C17.8384 17.6667 19.3334 16.1717 19.3334 14.3333C19.3334 12.495 17.8384 11 16 11C14.1617 11 12.6667 12.495 12.6667 14.3333C12.6667 16.1717 14.1617 17.6667 16 17.6667ZM16 12.6667C16.9192 12.6667 17.6667 13.4142 17.6667 14.3334C17.6667 15.2525 16.9192 16 16 16C15.0809 16 14.3334 15.2525 14.3334 14.3334C14.3334 13.4142 15.0809 12.6667 16 12.6667Z",
    fill: "#F1B44C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5167 24.1784C15.6617 24.2817 15.8308 24.3334 16 24.3334C16.1692 24.3334 16.3383 24.2817 16.4833 24.1784C16.7367 23.9992 22.6908 19.7001 22.6667 14.3334C22.6667 10.6576 19.6758 7.66675 16 7.66675C12.3242 7.66675 9.33333 10.6576 9.33333 14.3292C9.30916 19.7001 15.2633 23.9992 15.5167 24.1784ZM16 9.33344C18.7575 9.33344 21 11.5759 21 14.3376C21.0175 18.0359 17.3433 21.3568 16 22.4459C14.6575 21.3559 10.9825 18.0343 11 14.3334C11 11.5759 13.2425 9.33344 16 9.33344Z",
    fill: "#F1B44C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationYellow);
export default __webpack_public_path__ + "static/media/LocationYellow.64f763ed.svg";
export { ForwardRef as ReactComponent };